import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  searchValue: '',
  autocompleteSuggestions: {},
  requestAbortController: new AbortController(),
});

export { state, onChange };
export default state;
